<template>
	<el-dialog title="人员详细" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
		<el-table v-loading="loading" :data="showList" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" border>
			<el-table-column label="序号" align="center" width="60">
				<template slot-scope="scope">
					{{ scope.$index + 1 }}
				</template>
			</el-table-column>
			<el-table-column label="用户ID" align="center" prop="userCode"></el-table-column>
			<el-table-column label="姓名" align="center" prop="userName"></el-table-column>
			<el-table-column label="历史最高分" align="center" prop="score"></el-table-column>
			<el-table-column label="考试时间" align="center" prop="trainDate">
				<template slot-scope="scope">
					<span>{{ scope.row.trainDate.split(" ")[0] }}</span>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination
			background
			layout="prev, pager, next"
			:current-page.sync="form.pageNo"
			:page-size.sync="form.pageSize"
			:total="totalCount"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"></el-pagination>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" type="primary" @click="dialogVisible = false">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { courseSkillResultView } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			loading: false,
			form: {
				areaIds: "", //区域id
				agentId: "", //经销商id
				skillId: "", //技能id
				courseId: "", //课程id
				pageNo: 1,
				pageSize: 10,
			},
			totalCount: 0,
			showList: [],
		};
	},
	methods: {
		// 初始化弹窗
		init(dt) {
			this.dialogVisible = true;
			this.form.agentId = dt.agentId;
			this.form.skillId = dt.skillId;
			this.form.courseId = dt.courseId;
			this.form.areaIds = dt.areaIds;
			this.form.pageNo = 1;
			this.getList();
		},
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 获取列表
		getList() {
			this.loading = true;
			courseSkillResultView(this.form, false).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.showList = res.data.list;
				this.totalCount = res.data.totalCount;
				this.loading = false;
			});
		},
		handleSizeChange() {
			this.getList();
		},
		handleCurrentChange() {
			this.getList();
		},
	},
};
</script>

<style lang="scss" scoped>
.el-table ::v-deep td,
.el-table ::v-deep th {
	padding: 5px 0;
}
::v-deep .el-dialog__body {
	padding: 0 20px 15px;
}
.el-pagination {
	text-align: center;
	margin-top: 20px;
}
</style>
